import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/DoorAccess/g2StarterKit.jpg.mjs';
import '../../assets/product-list-assets/cameras/door-access/g2-starter-kit.jpg.mjs';
import { starterKits } from '../product-list-groups/starterKits.mjs';
import '../properties/index.mjs';
import { includedAccessories } from '../properties/includedAccessories.mjs';
import { includedHub } from '../properties/includedHub.mjs';
import { includedReaders } from '../properties/includedReaders.mjs';
import { touchPassSupport } from '../properties/touchPassSupport.mjs';
import v3Image__default from "../../../../assets/g2StarterKit.jpg";
import image__default from "../../../../assets/g2-starter-kit.jpg";
"use strict";
const g2StarterKit = {
  id: "g2StarterKit",
  productTitle: "G2 Starter Kit",
  description: "g2StarterKit.description",
  productListGroup: starterKits,
  descriptionMaxWidth: 200,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-g2-sk"],
  storePathParts: {
    category: "all-door-access",
    productSlug: "ua-g2-sk"
  },
  image: {
    src: image__default,
    width: 200,
    height: 160
  },
  v3Image: {
    src: v3Image__default,
    width: 327,
    height: 182
  },
  propertyValues: [{
    propertyId: includedHub.id,
    value: {
      type: "translation",
      value: "g2StarterKit.includedHub"
    }
  }, {
    propertyId: includedReaders.id,
    value: {
      type: "translation",
      value: "g2StarterKit.includedReaders"
    }
  }, {
    propertyId: includedAccessories.id,
    value: {
      type: "translation",
      value: "g2StarterKit.includedAccessories"
    }
  }, {
    propertyId: touchPassSupport.id,
    value: {
      type: "boolean",
      value: false
    }
  }]
};
export { g2StarterKit };
//# sourceMappingURL=g2StarterKit.mjs.map
